import React, { useState } from 'react';
import { Drawer, Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import CustomDrawerComponent from '../components/CustomDrawerComponent';
import BottomTabNavigation from './Navigation';

export default function DrawerNavigation() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Router>
      {/* Menu Button */}
      <IconButton
        onClick={() => setDrawerOpen(true)}
        sx={{ position: 'absolute', top: 15, left: 15, zIndex: 1300 }}
      >
        <MenuIcon />
      </IconButton>

      {/* MUI Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: 250, backgroundColor: '#fff' } }}
        BackdropProps={{ invisible: true }}
      >
        <CustomDrawerComponent />
      </Drawer>

      {/* Main Routes */}
      <Box sx={{ marginLeft: drawerOpen ? '250px' : '0px', transition: '0.3s' }}>
        <Routes>
          <Route path="*" element={<BottomTabNavigation />} />
        </Routes>
      </Box>
    </Router>
  );
}
